import { Responsive } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatListSupportItem } from '../../components/ChatListSupportItem';
import { ChatListWrapperLayout } from '../../components/ChatListWrapperLayout';
import { EmptyChatList } from '../../components/EmptyChatList';
import { useFeedbackForm } from '../../hooks/useFeedbackForm';
import { selectCurrentRoute, userSelector, selectChatListStatus, hostTypeSelector } from '../../selectors';
import { ERequestApiStatus } from '../../types/appState';
import { ERoute } from '../../types/route';
import { isIframeHostType } from '../../utils/isIframeHostType';
import { AuthNotificationContainer } from '../AuthNotificationContainer';
import { ChatListChatbotItemContainer } from '../ChatListChatbotItemContainer';

export const EmptyChatListContentContainer: React.FC = () => {
  const currentRoute = useSelector(selectCurrentRoute);
  const status = useSelector(selectChatListStatus);
  const { isAuthenticated } = useSelector(userSelector);
  const hostType = useSelector(hostTypeSelector);

  const isFrame = isIframeHostType(hostType);

  const { requestFeedbackForm } = useFeedbackForm();

  return (
    <>
      {currentRoute === ERoute.Messages && (
        <ChatListWrapperLayout>
          {!isFrame && <ChatListSupportItem onClick={requestFeedbackForm} />}

          <ChatListChatbotItemContainer />
        </ChatListWrapperLayout>
      )}

      {!isAuthenticated && (
        <Responsive phone tablet>
          <AuthNotificationContainer />
        </Responsive>
      )}

      {isAuthenticated && status === ERequestApiStatus.Succeed ? <EmptyChatList route={currentRoute} /> : null}
    </>
  );
};
